<template>
  <div v-if="tpOptions.showAttribute" class="le-tp-attribute">
    <el-tabs v-model="attributeActive" class="le-tp-attribute-card" @tab-click="handleTabsChangeEvent">
      <el-tab-pane label="画布属性" name="canvasAttribute">
        <div class="le-tp-attribute-body">
          <el-form ref="canvasForm" :model="canvasAttr" class="le-tp-form" :label-width="labelWidth" :size="formSize">
            <el-col :span="24">
              <el-form-item label="画布尺寸" prop="width">
                <el-col :span="11">
                  <el-input v-model="canvasAttr.width" readonly @change="handleStageSizeChangeEvent" />
                </el-col>
                <el-col class="line" :span="2"> -</el-col>
                <el-col :span="11">
                  <el-input v-model="canvasAttr.height" readonly @change="handleStageSizeChangeEvent" />
                </el-col>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="背景网格" class="le-tp-switch-item" prop="gridEnable">
                <el-switch v-model="canvasAttr.gridEnable" @change="handleEnableBgGridEvent" />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="背景颜色" prop="backgroundColor">
                <el-color-picker v-model="canvasAttr.backgroundColor" :show-alpha="true" :predefine="predefineColors" @change="handleBgColorChangeEvent" />
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="背景图片" prop="backgroundImage">
                <div class="le-tp-upload">
                  <el-upload
                    class="avatar-uploader"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="canvasAttr.backgroundImage" :src="canvasAttr.backgroundImage" class="avatar" alt="背景图片" />
                    <i v-else class="el-icon-plus avatar-uploader-icon" />
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
          </el-form>
        </div>
      </el-tab-pane>

      <!--      <el-tab-pane label="全局配置" name="globalAttribute">-->
      <!--        <le-tp-shape-global />-->
      <!--      </el-tab-pane>-->

      <el-tab-pane label="图形属性" name="shapeAttribute">
        <le-tp-shape-model @after-created="handleShapeModelAfterCreatedEvent" @change="handleShapeModelChangeEvent" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {childMixins, commonMixins} from '../../scripts/mixins';
import LeTpShapeModel from '../parts/le_tp_shape_model';
import {dataConst} from '../../scripts/conf';
import {attrCore} from '../../scripts/core/logic';

export default {
  name: 'LeTpAttribute',
  components: {LeTpShapeModel},
  mixins: [childMixins, commonMixins],
  data() {
    return {
      attributeActive: 'canvasAttribute',
      shapeAttrEmpty: true,
      labelWidth: '70px',
      formSize: 'mini',
      canvasAttr: {...attrCore.canvasAttribute},
      predefineColors: dataConst.predefineColors,
      selectedShapeNode: null,
      rules: {
        width: [
          { type: 'number', message: '只能是数字', trigger: ['blur', 'change'] }
        ]
      }
    };
  },
  created() {
    this.$nextTick(_ => {
      // 初始化画布大小
      this.initCanvasSize();
    });
  },
  methods: {
    initCanvasSize() {
      const stage = this.getCanvasStage();
      this.canvasAttr.width = stage.getWidth();
      this.canvasAttr.height = stage.getHeight();

      stage.on('custom:canvas:changeSize', (width, height) => {
        this.canvasAttr.width = width;
        this.canvasAttr.height = height;
      });
    },
    handleStageSizeChangeEvent() {
      const stage = this.getCanvasStage();
      stage.changeSize(Number(this.canvasAttr.width), Number(this.canvasAttr.height));
    },
    handleEnableBgGridEvent(val) {
      // 处理启用/禁用背景网格插件事件
      attrCore.handleEnableGridPluginEvent(this, val);
    },
    handleBgColorChangeEvent(val) {
      // 改变画布舞台背景颜色
      attrCore.handleBgColorChangeEvent(this, val);
    },
    handleShapeModelChangeEvent(model) {
      // 处理图形属性改变后渲染
      attrCore.handleShapeAttributeChangeEvent(this, model);
    },
    handleShapeModelAfterCreatedEvent() {
      // 处理图形属性组件加载成功后，触发图形属性激活
      attrCore.triggerShapeAttributeTabActive(this);
    },
    handleTabsChangeEvent(tab) {
      if (tab.name === 'shapeAttribute') {
        // 触发图形属性激活
        attrCore.triggerShapeAttributeTabActive(this);
      }
    },




    handleAvatarSuccess(res, file) {
      this.canvasAttr.backgroundImage = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    }
  }
};
</script>

<style scoped>

</style>
